import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage, Loading,
  LoadingController,
  NavController,
  NavParams,
  Platform, TextInput,
  ToastController
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {VizixService} from "../../providers/vizix.service";
import {Storage} from '@ionic/storage';
import {ConfigPage} from "../config/config";
import {DeviceSelectPage} from "../device-select/device-select";
import {User} from "../../models/LoginModel/User";
import {ConfigurationThing} from "../../models/configurationThing";
import {CycleCountService} from "../../providers/cyclecount.service";
import {deserialize} from "serializer.ts/Serializer";
import {
  CONFIG_CREATE_CONFIGURATION_FILE,
  CONFIG_FILE_NAME,
  CONFIG_FOLDER_FILE,
  DEFAULT_APP_VERSION,
  STORAGE_CONFIGURATION_THING,
  STORAGE_READER_SOUND_LEVEL,
  STORAGE_SET_UP_MODEL,
  STORAGE_SET_UP_MODEL_TEMP,
  STORAGE_TIME_OFFSET,
  STORAGE_USER, VALIDATION_INPUT_USER,
  VIZIX_EVENT_ID_LOGIN,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from "../../app/app.constants";
import {SetupModel} from "../../models/LoginModel/SetupModel";
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {File} from "@ionic-native/file";
import {SetupPage} from "../setup/setup";
import {UniqueDeviceID} from "@ionic-native/unique-device-id";
import {VizixEventService} from "../../providers/vizix.event.service";
import {HttpErrorResponse} from "@angular/common/http";
import {VizixEventItem} from "../../models/VizixEventItem";
import {ConfigurationFileService} from "../../providers/configuration.file.service";

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  private tag = '[LOGIN]';
  @ViewChild('inputUser')
  public inputText: any;
  @ViewChild('inputPassword')
  public inputPassword: any;
  public clientId: string;
  public vizixURL: string;
  public storeID: number;
  public user: User;
  private isRememberMeEnabled: boolean = true;
  private isSetupWizardEnabled: boolean = true;
  public disabledSeePassword: boolean;

  private result: boolean;

  private loginErrorAlert: any;
  isKeyboardOpen: boolean = false;

  private alertInvalidStoreId: Alert;
  private alertError: Alert;
  private alertErrorPermissions: Alert;
  private isAlert: boolean = false;
  public input_type: string = 'password';
  public show_password: boolean = false;
  public appVersion = DEFAULT_APP_VERSION;

  private dialogLoading: Loading;

  @ViewChild(Content) content: Content;
  @ViewChild('inputUser') inputUserField: TextInput;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private _vizixService: VizixService,
              private cycleCountService: CycleCountService,
              private vizixEventService: VizixEventService,
              public _toastCtrl: ToastController,
              public translate: TranslateService,
              private platform: Platform,
              private storage: Storage,
              private loadingCtrl: LoadingController,
              private file: File,
              //private keyboard: Keyboard,
              private cdr: ChangeDetectorRef,
              private androidPermissions: AndroidPermissions,
              private alertCtrl: AlertController,
              public configurationFileService: ConfigurationFileService,
              private uniqueDeviceID: UniqueDeviceID) {

    this.clientId = "web";
    this.user = new User("", "", false);
    this.disabledSeePassword = false;
    this.storeID = this._vizixService.getStoreId();
    platform.registerBackButtonAction(() => {
    });
    // window.addEventListener('native.keyboardshow', (e) => {
    //   this.keyboardHandler(e)
    // });
    // window.addEventListener('native.keyboardhide', (e) => {
    //   this.keyboardHandler(e)
    // });
  }

  // keyboardHandler(e) {
  //   setTimeout(() => {
  //     this.removeClone();
  //   }, 800);
  // }

  // removeClone() {
  //   let clonedInputList = this.inputText.getNativeElement().getElementsByClassName('input input-ios ng-dirty ng-touched ng-invalid cloned-input');
  //   console.log("Test method");
  //   if(clonedInputList.length > 0){
  //     console.log(clonedInputList);
  //     this.inputText.getNativeElement().getElementsByClassName('input input-ios ng-dirty ng-touched ng-invalid cloned-input')[0].remove();
  //     this.inputText.getNativeElement().getElementsByClassName('input-ios')[0].style.pointerEvents = '';
  //     this.inputText.getNativeElement().getElementsByClassName('input-ios')[0].style.opacity = '';
  //     this.inputText.getNativeElement().getElementsByClassName('input-ios')[0].style.transform = '';
  //     this.inputText.getNativeElement().getElementsByClassName('text-input-ios')[0].style.transform = '';
  //   }
  //
  //   let clonedInputListP = this.inputPassword.getNativeElement().getElementsByClassName('input input-ios ng-dirty ng-touched ng-invalid cloned-input');
  //   console.log("Test method jeje");
  //   console.log(clonedInputListP);
  //   if(clonedInputListP.length > 0){
  //     this.inputPassword.getNativeElement().getElementsByClassName('cloned-input')[0].remove();
  //     this.inputPassword.getNativeElement().getElementsByClassName('input-ios')[0].style.pointerEvents = '';
  //     this.inputPassword.getNativeElement().getElementsByClassName('input-ios')[0].style.opacity = '';
  //     this.inputPassword.getNativeElement().getElementsByClassName('input-ios')[0].style.transform = '';
  //     this.inputPassword.getNativeElement().getElementsByClassName('text-input-ios')[0].style.transform = '';
  //   }
  // }


  ionViewWillEnter() {
    /*this.keyboard.onKeyboardShow().subscribe(() => {
      this.isKeyboardOpen = true;
      this.content.resize();
    });
    this.keyboard.onKeyboardHide().subscribe(() => {
      this.isKeyboardOpen = false;
      this.content.resize();
    });*/
    this.cdr.reattach();
  }

  ionViewWillLeave() {
    this.cdr.detach();
  }

  ionViewDidLoad() {
    this.platform.ready().then(() => {
      // validate if setup config exist and get the permissions of the phone
      if (this.platform.is('cordova')) {
        this.translate.getTranslation('en').subscribe(() => {
          this.initAlerts();
          this.checkForPermissionsAndInit();
        });
      } else {
        console.log(this.tag, 'Cordova not available or plugin error, skipping permission check');
        this.ExistsSetup();
      }

      // if the user activated remember password
      this.UploadUser();

      // init login error alert
      this.initLoginErrorAlert();
    });

    this.vizixEventService.init();
  }

  checkForPermissionsAndInit() {
    this.androidPermissions.requestPermissions([
      this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE,
      this.androidPermissions.PERMISSION.GET_ACCOUNTS,
      this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION,
      this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
      this.androidPermissions.PERMISSION.READ_PHONE_STATE,
      this.androidPermissions.PERMISSION.CAMERA]
    ).then(
      success => {
        console.log(this.tag, 'User granted permission');
        this.ExistsSetup();

        // Get the session ID, the UUID and the current username
        this.uniqueDeviceID.get()
          .then((uuid: any) => this.clientId = String(uuid))
          .catch((error: any) => this.clientId = '-');
      },
      err => {
        console.log(this.tag, 'error permissions', err);
        this.initAlertErrorPermissions();
        this.alertErrorPermissions.present();
      }
    );
  }

  initAlerts() {
    this.initAlertError();
    this.initAlertStoreIdNotValid();
    this.initAlertErrorPermissions();
  }

  // Alert that shows when there is an invalid store id
  initAlertStoreIdNotValid() {
    this.alertInvalidStoreId = this.alertCtrl.create({
      title: this.translate.instant('setup.alerts.invalid_store_id.title'),
      message: this.translate.instant('setup.alerts.invalid_store_id.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('setup.alerts.invalid_store_id.ok'),
          handler: () => {
            this.initAlertStoreIdNotValid(); // We call this recursively because the alert is destroyed on dismiss
          }
        },
      ]
    });
  }

  // Alert that shows when an error occurs
  initAlertError() {
    this.alertError = this.alertCtrl.create({
      title: this.translate.instant('setup.alerts.error.title'),
      message: this.translate.instant('setup.alerts.error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('setup.alerts.error.ok'),
          handler: () => {
            this.initAlertError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when an error occurs and needs to exit later
  initAlertErrorPermissions() {
    this.alertErrorPermissions = this.alertCtrl.create({
      title: this.translate.instant('setup.alerts.error_permissions.title'),
      message: this.translate.instant('setup.alerts.error_permissions.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('setup.alerts.error_permissions.ok'),
          handler: () => {
            this.checkForPermissionsAndInit();
            this.initAlertErrorPermissions(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  initLoginErrorAlert() {
    this.loginErrorAlert = this.alertCtrl.create({
      title: this.translate.instant('login.alerts.error.title'),
      subTitle: this.translate.instant('login.alerts.error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('login.alerts.error.ok'),
          handler: () => {
            this.login();
            this.initLoginErrorAlert();
          }
        },
        {
          text: this.translate.instant('login.alerts.error.cancel'),
          handler: () => {
            this.initLoginErrorAlert();
          }
        }
      ]
    });
  }

  private ExistsConfigThing() {
    this.storage.get(STORAGE_CONFIGURATION_THING).then(storageConfigurationThing => {
      if (!storageConfigurationThing) {
        // if not exist config get the configs and validate de store id if store is incorrect setup again
        this._vizixService.VizixGetConfigList().subscribe((data: ConfigurationThing[]) => {
            this.dialogLoading.dismiss().then(() => {
              if (data.length > 1) {
                this.navCtrl.push(ConfigPage, {configurations: data});
              } else if (data.length === 1) {
                this._vizixService.setConfigurationApp(data[0]);
                this.storage.set(STORAGE_SET_UP_MODEL, data[0]).then(() => {
                  this.storage.remove(STORAGE_SET_UP_MODEL_TEMP).then(()=>{
                    this.navCtrl.push(DeviceSelectPage);
                  });
                });
              } else {
                this.alertInvalidStoreId.present();
                this.navCtrl.push(SetupPage);
              }

              this.saveLoginEvent();
            });
          },
          err => {
            this.dialogLoading.dismiss().then(() => {
              this.alertError.present();
              this.navCtrl.push(SetupPage);
            });
          });
      } else {
        this.dialogLoading.dismiss().then(() => {
          let configurationThing = deserialize<ConfigurationThing>(ConfigurationThing, storageConfigurationThing);
          this._vizixService.setConfigurationApp(configurationThing);
          this.saveLoginEvent();
          this.navCtrl.push(DeviceSelectPage);
        });
      }
    }, rejectedReason => {
      this.dialogLoading.dismiss().then(() => {
        console.log(this.tag, rejectedReason);
        this.navCtrl.push(SetupPage);
      });
    });
  }

  private saveLoginEvent() {
    console.log(this.tag, 'Init save login event');
    this.vizixEventService.getVizixEventItemBase().then((vizixEvent: VizixEventItem) => {
      vizixEvent.action = VizixEventAction.NONE;
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.AUTHENTICATION;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.eventId = VIZIX_EVENT_ID_LOGIN;
      vizixEvent.activity = VizixEventActivity.LOGIN;
      this.vizixEventService.recordEvent(vizixEvent);
    }, (error) => {
      console.log(this.tag, 'Error getting VizixItemBase', error);
    })
  }

  private UploadUser() {
    this.storage.get(STORAGE_USER).then((user) => {
      if (!user) {
        this.user = new User("", "", false);
      }
      else {
        this.disabledSeePassword = true;
        this.user = user;
        this.user.userName = atob(this.user.userName);
        this.user.password = atob(this.user.password);
      }
    }, rejectedReason => {
      this.user = new User("", "", false);
    });
  }

  public resetSettings() {
    this.ShowAlertOkCancel(this.translate.instant("login.alerts.resetALL.title"),
      this.translate.instant("login.alerts.resetALL.message"),
      this.translate.instant("login.alerts.resetALL.ok"),
      () => {
        this.resetAllSettingsAndStorage();
        this.navCtrl.push(SetupPage);
      },
      this.translate.instant("login.alerts.resetALL.cancel"),
    );
  }

  private resetAllSettingsAndStorage() {
    //Removing sound level
    this.storage.remove(STORAGE_READER_SOUND_LEVEL).then(() => {
      console.log(this.tag, 'Sound reader level Removed');
    }, (err) => {
      console.log(this.tag, 'Error removing Sound reader level', err);
    });
    // removing storage
    this.storage.clear().then(() => {
      console.log(this.tag, "Removed all Storage success");
    }, error => {
      console.log(this.tag, "Error Removed all Storage", error);
    });
    // removing file of configuration
    this.file.removeFile(this.file.externalRootDirectory + CONFIG_FOLDER_FILE, CONFIG_FILE_NAME).then(() => {
      console.log(this.tag, "Removed FILE success");
    }, error => {
      console.log(this.tag, "Error Removed FILE ", error);
    });
    // reseting variables of vizixService
    this._vizixService.clearVizixService();
    // removing DBs
    this.vizixEventService.deleteDataBase();
    this.cycleCountService.deleteDataBase();
  }

  ShowAlertOkCancel(title: string, messageText: string, okText: string, callbackOk: () => void, cancelText: string, callbackCancel?: () => void) {
    let alert = this.alertCtrl.create({
      title: title,
      message: messageText,
      buttons: [
        {
          text: cancelText,
          role: 'cancel',
          handler: () => {
            if (callbackCancel) {
              callbackCancel();
            }
          }
        },
        {
          text: okText,
          handler: () => {
            callbackOk();
            // return false; // to not dismiss the alert
          }
        }
      ]
    });
    alert.present();
  }

  public login() {

    this.dialogLoading = this.loadingCtrl.create({
      content: this.translate.instant('login.loading.authenticating')
    });

    this.dialogLoading.present();
    this._vizixService.VizixLogin(this.user.userName, this.user.password).subscribe((data: boolean) => {
        this.result = data;
        this._vizixService.timestamp().subscribe((response: { offset: number, timestamp: number }) => {
          const local = new Date().getTime();
          const currentOffset = local - response.timestamp;
          localStorage.setItem(STORAGE_TIME_OFFSET, currentOffset.toString());
        });
      },
      err => {
        console.error('VizixLogin', err);
        this.dialogLoading.dismiss();
        let error = err['error'] || err['message'];

        if (error instanceof ProgressEvent || (err instanceof HttpErrorResponse && (err.status === 404 || err.status === 0))) {
          this.showErrorAlert(this.translate.instant('login.alerts.error.message'));
        } else {
          let errorString: string = JSON.stringify(error);
          if (typeof errorString === 'string' && (errorString.includes('"error":') || errorString.includes('"message":'))) {
            let json = JSON.parse(errorString);
            this.user.password = '';
            this.showErrorAlert(json["error"] || json["message"]);
          } else {
            this.showErrorAlert(this.translate.instant('login.toasts.unknownError'));
          }
        }
      },
      () => {

        if (this.user.rememberMe) {
          let userStorage: User = new User(this.user.userName, this.user.password, this.user.rememberMe);
          userStorage.userName = btoa(userStorage.userName);
          userStorage.password = btoa(userStorage.password);
          this.storage.set(STORAGE_USER, userStorage);
        } else {
          this.storage.remove(STORAGE_USER);
        }
        // Verify if exist a configuration
        this.ExistsConfigThing();
      });

  }

  // Check if we have a setup already saved in storage, if not, we check if we have the file in the SD card (android)
  // so we get the information from there and init the vizix service. If we don't have both, we just leave the user to enter
  // the values.

  private ExistsSetup() {

    console.log(this.tag, "Setup model from Storage: ", this.storage.get(STORAGE_SET_UP_MODEL));

    this.storage.get(STORAGE_SET_UP_MODEL).then(setup => {


      if (setup) {
        console.log(this.tag, 'SetupModel found');
        let setupConfig = <SetupModel> setup;
        this._vizixService.VizixInit(setupConfig.host, setupConfig.port, setupConfig.protocol, this.clientId);
        this._vizixService.setStoreId(setupConfig.storeID);
        this.storeID = this._vizixService.getStoreId();
      } else {


        try {
          console.log(this.tag, 'SetupModel not found, searching external storage file'); // TODO: Move path to constants
          this.file.checkFile(this.file.externalRootDirectory + CONFIG_FOLDER_FILE, CONFIG_FILE_NAME).then(result => {
              if (result) {
                console.log(this.tag, 'File found, reading the values');
                this.file.readAsText(this.file.externalRootDirectory + CONFIG_FOLDER_FILE, CONFIG_FILE_NAME).then(fileStr => {
                  console.log(this.tag, fileStr);
                  let fileObj = JSON.parse(String(fileStr).trim());
                  console.log(this.tag, fileObj);
                  let setup: SetupModel = new SetupModel("", "", "", 0);
                  setup.host = fileObj.URL.split('//')[1];
                  // setup.port = fileObj.URL.split(':')[2];
                  setup.protocol = fileObj.URL.split('//')[0] + '//';
                  setup.storeID = fileObj.StoreID;

                  this.isRememberMeEnabled = fileObj.isRememberMeEnabled;
                  this.isSetupWizardEnabled = fileObj.isSetupWizardEnabled;
                  this.cdr.detectChanges();
                  this.content.resize();

                  this._vizixService.VizixInit(setup.host, setup.port, setup.protocol, this.clientId);
                  this._vizixService.setStoreId(setup.storeID);
                  this.storeID = this._vizixService.getStoreId();
                  console.log(this.tag, 'File setup applied'); // TODO: DELETE FILE?
                }, err => {
                  console.log(this.tag, 'error reading file');
                  console.log(this.tag, err);
                  this.navCtrl.push(SetupPage);
                }).catch(error => {
                  console.log(this.tag, error);
                  this.navCtrl.push(SetupPage);
                });
              } else {
                this.navCtrl.push(SetupPage);
              }
            },
            error => {
              console.log(this.tag, "No file found then begin to create Config file if there are config file values", error);
              if (CONFIG_CREATE_CONFIGURATION_FILE) {
                console.log(this.tag, "CREATE CONFIGURATION FILE ENABLED");
                this.configurationFileService.createConfigurationFile().subscribe(
                  (response: any) => {
                    console.log(this.tag, response);
                    console.log(this.tag, "Creating configuration file");
                    this.ExistsSetup();
                  }, (error) => {
                    console.error("Error creating cofiguration file");
                    this.navCtrl.push(SetupPage)
                  }
                );
              }
              else {
                console.log(this.tag, "CREATE CONFIGURATION FILE DISABLED");
                this.navCtrl.push(SetupPage)
              }
            });
        } catch (exception) {
          console.log(this.tag, exception);
          this.navCtrl.push(SetupPage)
        }
      }
    }, rejectedReason => {
      console.log(this.tag, rejectedReason);
      this.navCtrl.push(SetupPage)
    });
  }

  /*ShowToast(messageText: string) {
    let toast = this._toastCtrl.create({
      message: messageText,
      duration: 2500,
      position: 'bottom'
    });
    toast.present();
  }*/

  showPassword() {
    this.show_password = !this.show_password;

    if (this.show_password) {
      this.input_type = 'text';
    } else {
      this.input_type = 'password';
    }
  }

  enableSeePassword(event) {
    if (this.user.password.length === 0) {
      this.disabledSeePassword = false;
    }
  }

  showErrorAlert(errorMessage) {
    if (!this.isAlert) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('login.alerts.login_error.title'),
        message: errorMessage,
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('login.alerts.login_error.ok'),
            handler: () => {
              this.isAlert = false;
              console.log(this.tag, 'Ok clicked');
            }
          }
        ]
      });
      this.isAlert = true;
      alert.onDidDismiss(() => {
        this.isAlert = false;
      });
      alert.present();
    }
  }

  validateForm() {
    return !(this.user.userName && this.user.password);
  }

  onKeyDownUser(event) {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression = new RegExp(VALIDATION_INPUT_USER);
    if (!regExpression.test(<string>charPressed.toUpperCase())) {
      this.user.userName = event.replace(charPressed, '');
      this.inputUserField.value = this.user.userName;
      this.cdr.detectChanges();
    }
    else {
      this.user.userName = event;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts